import PropTypes from 'prop-types'

/**
 * @typedef {Object} BatteryCurveEntry
 *
 * Maximum power drawn during charging operation over different charging level of battery
 *
 * @property {number} maxPowerInkW - Maximum draw power from the power supply in kW unit
 * @property {number} stateOfChargeInkWh - State of battery charge in kWh unit
 */
export const batteryCurveEntryPropType = PropTypes.shape({
    maxPowerInkW: PropTypes.number.isRequired,
    stateOfChargeInkWh: PropTypes.number.isRequired
})
